export default "__VITE_ASSET__CxXgKM7e__"